import {useEffect} from 'react';

import {DialogContent, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import {func} from 'prop-types';

import {CONNECTOR_LOGIN_PROCESS_TYPE_LOCALSTORAGE_KEY} from '../../../../const';
import useProjects from '../../../../hooks/providers/useProjects';
import Button from '../../../form/buttons/Button/Button';
import BaseModal from '../../../modal/BaseModal';

const ChooseConnectorLoginProcessModal = ({resetConnectionForm}) => {
  const {connector, isChooseLoginToConnectorProcessModalOpen: isOpen, setIsChooseLoginToConnectorProcessModalOpen: setIsOpen, redirectToConnectorLoginPage} = useProjects();

  const onClose = () => {
    setIsOpen(false);
  };

  const handleLoginProcessSelect = process => {
    if (!process.is_enabled) return;
    onClose();

    localStorage.setItem(CONNECTOR_LOGIN_PROCESS_TYPE_LOCALSTORAGE_KEY, process.id);
    if (process.oauth) {
      redirectToConnectorLoginPage(connector.id, {
        scope: process.scopes,
        clientId: process.client_id,
        formId: process.id
      });
    }
  };

  useEffect(() => {
    localStorage.removeItem(CONNECTOR_LOGIN_PROCESS_TYPE_LOCALSTORAGE_KEY);
  }, []);

  return (
    <BaseModal
      canCloseOnBackdropClick={false}
      hasCloseIcon
      open={isOpen}
      title="Choisissez votre type de connexion"
      onClose={() => {
        onClose();
        resetConnectionForm();
      }}
    >
      <DialogContent sx={{p: 3}}>
        <Grid container spacing={2} mt={1.5}>
          {(connector?.forms || []).map(f => {
            return (
              <Button
                key={f.id}
                disabled={!f.is_enabled}
                variant="outlined"
                onClick={() => handleLoginProcessSelect(f)}
                xs={12}
                fullWidth
                sx={{
                  background: f.is_enabled ? '' : '#DEDEDE',
                  textAlign: 'center',
                  cursor: f.is_enabled ? 'pointer' : 'not-allowed',
                  borderRadius: 20,
                  p: 2,
                  mb: 2
                }}
              >
                <Typography fontWeight="bold">{f.label}</Typography>
              </Button>
            );
          })}
        </Grid>
      </DialogContent>
    </BaseModal>
  );
};

ChooseConnectorLoginProcessModal.propTypes = {
  resetConnectionForm: func.isRequired
};

export default ChooseConnectorLoginProcessModal;
